import { Article } from '~src/types/article'
import Damasteel from './_Damasteel.article'
import Damasteel2 from './_Damasteel2.article'
import Damasteel3 from './_Damasteel3.article'
import Powder from './_Powder.article'
import BestSteel from './_BestSteel.article'

export default [
  BestSteel,
  Damasteel,
  Damasteel2,
  Damasteel3,
  Powder,
] as Article[]
